//#region src/variants/variants_lazy_show.js
var variants_lazy_show_default = {
	default: {
		props: { show: { initialValue: true } },
		slots: { default: { initialValue: "I'm Lazy!" } }
	},
	"with transition": {
		props: {
			transition: { initialValue: "fade" },
			show: { initialValue: true }
		},
		slots: { default: { initialValue: "I'm Lazy!" } }
	}
};
//#endregion
export { variants_lazy_show_default as default };

//# sourceMappingURL=variants_lazy_show.js.map